// Acknowledge their struggles - build trust
import FeedbackPage from '@/components/FeedbackPage'

export default function ObstaclesAcknowledgePage() {
  return (
    <FeedbackPage
      emoji="🤝"
      title="pages.onboarding.obstaclesAcknowledge.title"
    />
  )
}
